<template>
    <TMobileItems
        :footer-button-text="$t('ui.close')"
        class="o-mobile-plan mobile-plan"
        @onFooterButton="handleClickFooterButton"
    >
        <template #header>
            <AMHeaderItems
                :title="$t('ui.plan-category')"
                :subtitle="$t('ui.plan-category.description')"
            >
                <template #left>
                    <div class="mobile-plan__header-wrapper">
                        <button
                            type="button"
                            role="button"
                            class="mobile-plan__header-button"
                            :aria-label="ariaLabelToHome"
                            @click="redirectToHome"
                        >
                            <svg-icon
                                original
                                name="icons/arrow-down"
                                class="mobile-plan__header-button-icon"
                            />
                        </button>
                        <svg-icon
                            original
                            name="icons/plan"
                            class="mobile-plan__header-icon"
                        />
                    </div>
                </template>
                <template #right>
                    <span />
                </template>
            </AMHeaderItems>
        </template>
        <template #container>
            <button
                role="button"
                v-for="(zone, index) in getTargetZones"
                :key="index"
                type="button"
                class="mobile-plan__button"
                :aria-label="ariaLabelShowZoom"
                @click="showZone(zone)"
            >
                <span class="mobile-plan__title">
                    {{ t(zone, 'name')}}
                </span>
            </button>
        </template>
    </TMobileItems>
</template>

<script>
import { mapGetters } from 'vuex';
    
import TMobileItems from '../../templates/t-mobile-items/t-mobile-items';
import AMHeaderItems from '../../atoms/a-m-header-items/a-m-header-items';

import { MAP_SHOW_OBJECT } from "../../../shared/components/map-viewer/constants/map-commands";
import { MOBILE_ROOT } from '../../../utils/constants/pages';

export default {
    name: 'OMobilePlan',
    components: {
        TMobileItems,
        AMHeaderItems
    },
    props: {
        ariaLabelToHome: {
            type: String,
            default: 'Redirect to home'
        },
        ariaLabelShowZoom: {
            type: String,
            default: 'Show zoom'
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getMvData',
            'getServices',
            'getTargetZones',
            'getDenormalisedObjectById'
        ]),
        categoryServices() {
            return this.getServices.filter(item => item.lists.categories.includes(this.getMvData.config.categories['target_zone_service_category']));
        }
    },
    methods: {
        handleClickFooterButton() {
            this.redirectToHome();
        },
        redirectToHome() {
            const params = {
                name: MOBILE_ROOT
            };
            this.$router.push(params);
        },
        showZone(zone) {
            const obj = this.getDenormalisedObjectById(this.categoryServices.filter(item => item.lists['target_zone'] === zone.id)[0].id);

            this.$bus.$emit(MAP_SHOW_OBJECT, {
                id: obj.id,
                unit_id: obj.unit.id
            });
            this.redirectToHome();
        }
    }
}
</script>

<style lang="scss">
@import "o-mobile-plan";
</style>